/* Shared cart drawer. Prices and stock controls are rendered by Shopify. */
window.addEventListener('load', function () {
  var $ = window.jQuery;
  var drawer = document.getElementById('popup-cart-header');
  if (!drawer || drawer.dataset.initialized) return;
  drawer.dataset.initialized = 'true';
  var popup = $(drawer);
  var cartUrl = drawer.dataset.cartUrl;
  var sectionNames = ['cart-drawer-items', 'shippings', 'cart-module--related'];
  var walletSlot = drawer.querySelector('[data-cart-wallet-slot]');
  var pageWallets = document.querySelector('[data-cart-page-wallets]');
  var walletsLoaded = false;
  var busy = false;
  var version = 0;
  var readController;
  var trigger;
  var isOpen = false;
  var inertElements = [];
  var errorBox = drawer.querySelector('.module-popup_error');
  var stale = false;
  var pageChanged = false;
  var needsPageRefresh = false;
  var onCartPage = drawer.dataset.pageType === 'cart';

  function message(text, retry) {
    errorBox.querySelector('span').textContent = text || '';
    errorBox.hidden = !text;
    errorBox.querySelector('[data-cart-retry]').hidden = !retry;
  }

  function setBusy(value) {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    drawer.querySelectorAll('.popup-cart-quantity, .popup-cart-remove, [name="checkout"]').forEach(function (el) {
      el.disabled = value || (stale && el.name === 'checkout');
    });
    // Prevent express checkout while the visible cart is being updated.
    drawer.querySelector('.module-popup_checkout').inert = value || stale;
  }

  function errorText(error) {
    return error.description || drawer.dataset.errorMessage;
  }

  async function request(url, options) {
    var response = await fetch(url, Object.assign({ credentials: 'same-origin' }, options));
    var data = await response.json();
    if (!response.ok) throw data;
    return data;
  }

  function parse(markup) {
    return new DOMParser().parseFromString(markup, 'text/html');
  }

  function importContent(target, source) {
    target.replaceChildren();
    if (!source) return;
    // Section scripts are not needed here. Wallet initialization uses Shopify's
    // registered web components, not execution of fetched inline scripts.
    source.querySelectorAll('script').forEach(function (el) { el.remove(); });
    Array.from(source.childNodes).forEach(function (node) {
      target.appendChild(document.importNode(node, true));
    });
  }

  function prepareWallets(doc) {
    var selectors = {
      shop_pay: 'shop-pay-wallet-button', paypal: 'shopify-paypal-button',
      google_pay: 'shopify-google-pay-button', apple_pay: 'shopify-apple-pay-button, apple-pay-wallet-button'
    };
    var classes = { shop_pay: 'shop-pay', paypal: 'paypal', google_pay: 'google-pay', apple_pay: 'apple-pay' };
    doc.querySelectorAll('.cart-quick_checkout').forEach(function (wrap) {
      var disabled = Object.keys(classes).filter(function (name) { return wrap.classList.contains('hide-wallet_' + classes[name]); });
      var component = wrap.querySelector('shopify-accelerated-checkout-cart');
      if (component && component.hasAttribute('wallet-configs')) {
        try {
          var configs = JSON.parse(component.getAttribute('wallet-configs'));
          component.setAttribute('wallet-configs', JSON.stringify(configs.filter(function (config) { return disabled.indexOf(config.name) === -1; })));
        } catch (error) { /* CSS keeps the configured fallback. */ }
      }
      disabled.forEach(function (name) { wrap.querySelectorAll(selectors[name]).forEach(function (el) { el.remove(); }); });
    });
    // Only load Shopify's external wallet assets, once, after the drawer is used.
    // Never execute arbitrary inline scripts from fetched section markup.
    doc.querySelectorAll('script[src]').forEach(function (source) {
      var url = new URL(source.getAttribute('src'), location.origin);
      if (url.protocol !== 'https:' || !(url.origin === location.origin || /(^|\.)shopify\.com$/.test(url.hostname))) return;
      if (Array.from(document.scripts).some(function (script) { return script.src === url.href; })) return;
      var script = document.createElement('script');
      script.src = url.href;
      if (source.type) script.type = source.type;
      script.async = false;
      script.addEventListener('load', function () {
        if (window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
      });
      document.head.appendChild(script);
    });
  }

  function restoreWallets() {
    if (pageWallets) {
      while (walletSlot.firstChild) pageWallets.appendChild(walletSlot.firstChild);
    }
  }

  function usePageWallets() {
    if (!pageWallets) return;
    while (pageWallets.firstChild) walletSlot.appendChild(pageWallets.firstChild);
    walletsLoaded = true;
  }

  function render(sections, focusKey) {
    if (!sections || !sections['cart-drawer-items'] || !sections.shippings) throw new Error('Missing cart sections');
    var itemsDoc = parse(sections['cart-drawer-items']);
    var state = itemsDoc.querySelector('[data-cart-drawer-state]');
    if (!state) throw new Error('Missing cart state');
    var totals = parse(sections.shippings).querySelector('table');
    if (!totals) throw new Error('Missing cart totals');
    importContent(drawer.querySelector('[data-cart-items]'), state.parentElement);
    drawer.querySelector('.module-popup_summary-totals').replaceChildren(document.importNode(totals, true));
    var related = sections['cart-module--related'] ? parse(sections['cart-module--related']).querySelector('.module-products--wrapper') : null;
    var relatedTarget = drawer.querySelector('.module-popup_related');
    relatedTarget.replaceChildren();
    if (related) {
      related.querySelectorAll('script').forEach(function (el) { el.remove(); });
      relatedTarget.appendChild(document.importNode(related, true));
      if (window.CartSuggestions) window.CartSuggestions.load(relatedTarget);
    }
    if (!walletsLoaded && Object.prototype.hasOwnProperty.call(sections, 'cart-drawer-wallets')) {
      if (sections['cart-drawer-wallets'] === null) throw new Error('Missing wallet section');
      var wallets = parse(sections['cart-drawer-wallets']);
      prepareWallets(wallets);
      importContent(walletSlot, wallets.querySelector('.shopify-section') || wallets.body);
      walletsLoaded = true;
      if (window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
    }
    var count = Number(state.dataset.count);
    $('.cart-total').text(count);
    $('.module-gifts').each(function () {
      $(this).toggleClass('reached', Number(state.dataset.total) >= Number($(this).data('reach')));
    });
    drawer.querySelector('#cart-drawer-title').textContent = count === 0 ? drawer.dataset.emptyTitle : drawer.dataset.cartTitle;
    ['.module-popup_checkout', '.module-popup_summary-totals'].forEach(function (selector) {
      var element = drawer.querySelector(selector);
      element.hidden = count === 0;
      // The form's display:grid must not override the empty state.
      element.style.display = count === 0 ? 'none' : '';
    });
    if (focusKey && isOpen) {
      var item = Array.from(drawer.querySelectorAll('[data-cart-item-key]')).find(function (el) { return el.dataset.cartItemKey === focusKey.key; });
      var next = item && item.querySelector(focusKey.selector);
      (next || drawer.querySelector('[data-cart-close]')).focus();
    }

  }

  function requestedSections() {
    return sectionNames.concat(walletsLoaded || pageWallets ? [] : ['cart-drawer-wallets']);
  }

  async function refresh(focusKey) {
    var current = ++version;
    if (readController) readController.abort();
    readController = new AbortController();
    var url = new URL(cartUrl, window.location.origin);
    url.searchParams.set('sections', requestedSections().join(','));
    var sections = await request(url, { signal: readController.signal });
    if (current !== version) return;
    render(sections, focusKey);
    stale = false;
  }

  function focusables() {
    return Array.from(drawer.querySelectorAll('button:not(:disabled), a[href], select:not(:disabled), input:not(:disabled), iframe, [tabindex="0"]')).filter(function (el) {
      return !el.hasAttribute('data-cart-focus-start') && !el.hasAttribute('data-cart-focus-end') && el.getClientRects().length && !el.closest('[hidden], [inert]');
    });
  }

  function open(opener) {
    if (isOpen) return;
    trigger = opener || document.activeElement;
    isOpen = true;
    usePageWallets();
    document.querySelectorAll('[data-cart-trigger]').forEach(function (el) { el.setAttribute('aria-expanded', 'true'); });
    Array.from(document.body.children).forEach(function (el) {
      if (el === drawer || el.contains(drawer) || el.inert || /^(SCRIPT|STYLE|LINK)$/.test(el.tagName)) return;
      el.inert = true;
      inertElements.push(el);
    });
    $('body').addClass('overlay transition');
    popup.find('.module-popup_content').show();
    popup.show('slide', {
      direction: 'right',
      easing: $.bez ? $.bez([.45, .05, .19, 1]) : 'swing',
      complete: function () {
        $('body').removeClass('transition');
        if (isOpen) drawer.querySelector('[data-cart-close]').focus();
      }
    }, 600);
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    popup.stop(true, true).hide();
    $('body').removeClass('overlay transition');
    inertElements.forEach(function (el) { el.inert = false; });
    inertElements = [];
    document.querySelectorAll('[data-cart-trigger]').forEach(function (el) { el.setAttribute('aria-expanded', 'false'); });
    restoreWallets();
    if (trigger && trigger.isConnected) trigger.focus();
    needsPageRefresh = onCartPage && (pageChanged || busy);
    if (needsPageRefresh && !busy) window.location.reload();
  }

  async function showCart(opener, fallback) {
    if (busy || isOpen) return;
    setBusy(true);
    try {
      usePageWallets();
      await refresh();
      // Opening alone does not mutate the page cart.
      open(opener);
      message('');
    } catch (error) {
      restoreWallets();
      if (fallback) window.location.assign(fallback);
      else { open(opener); stale = true; message(errorText(error), true); }
    } finally { setBusy(false); }
  }

  async function mutate(url, data, focusKey) {
    if (busy) return;
    setBusy(true);
    message('');
    ++version;
    if (readController) readController.abort();
    var committed = false;
    pageChanged = true;
    try {
      var sections = requestedSections();
      data.append('sections', sections.join(','));
      data.append('sections_url', cartUrl);
      var result = await request(url, { method: 'POST', body: data });
      committed = true;
      try {
        render(result.sections, focusKey);
      } catch (error) {
        await refresh(focusKey);
      }
      stale = false;
    } catch (error) {
      if (committed) {
        stale = true;
      } else {
        // A lost response or a stock error can still leave the server cart
        // changed. Reconcile by reading it; never repeat the mutation.
        try { await refresh(focusKey); } catch (readError) { stale = true; }
      }
      message(errorText(error), stale);
      // The select's data-quantity is the last server-confirmed value.
      drawer.querySelectorAll('.popup-cart-quantity').forEach(function (el) { el.value = el.dataset.quantity; });
      throw error;
    } finally {
      setBusy(false);
      if (needsPageRefresh && !isOpen) window.location.reload();
    }
  }

  $(document).on('click', '[data-cart-trigger]', function (event) {
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopPropagation();
    showCart(this, this.href);
  });
  popup.on('click', '[data-cart-close]', function (event) { event.stopPropagation(); close(); });
  popup.on('click', '.popup-cart-remove', function () {
    var data = new FormData();
    var key = this.closest('[data-cart-item-key]').dataset.cartItemKey;
    data.append('id', key);
    data.append('quantity', '0');
    mutate(drawer.dataset.changeUrl, data, { key: key, selector: '.popup-cart-remove' }).catch(function () {});
  });
  popup.on('change', '.popup-cart-quantity', function () {
    var data = new FormData();
    var key = this.closest('[data-cart-item-key]').dataset.cartItemKey;
    data.append('id', key);
    data.append('quantity', this.value);
    mutate(drawer.dataset.changeUrl, data, { key: key, selector: '.popup-cart-quantity' }).catch(function () {});
  });
  popup.on('click', '[data-cart-retry]', async function () {
    if (busy) return;
    setBusy(true);
    try { await refresh(); message(''); drawer.querySelector('[data-cart-close]').focus(); } catch (error) { message(errorText(error), true); }
    finally { setBusy(false); }
  });
  $(document).on('submit', 'form.product-form', async function (event) {
    var action = new URL(this.action, location.origin);
    if (action.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(action.pathname)) return;
    event.preventDefault();
    if (busy) return;
    var opener = this.querySelector('[type="submit"]');
    var data = new FormData(this);
    usePageWallets();
    try {
      await mutate(drawer.dataset.addUrl, data);
      open(opener);
    } catch (error) {
      open(opener);
      message(errorText(error), stale);
    }
  });
  document.addEventListener('keydown', function (event) {
    if (!isOpen) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); }
    if (event.key === 'Tab') {
      var elements = focusables();
      if (!elements.length) { event.preventDefault(); drawer.focus(); }
      else if (event.shiftKey && (document.activeElement === elements[0] || document.activeElement === drawer)) {
        event.preventDefault(); elements[elements.length - 1].focus();
      } else if (!event.shiftKey && document.activeElement === elements[elements.length - 1]) {
        event.preventDefault(); elements[0].focus();
      }
    }
  });
  drawer.querySelector('[data-cart-focus-start]').addEventListener('focus', function () { var els = focusables(); (els[els.length - 1] || drawer).focus(); });
  drawer.querySelector('[data-cart-focus-end]').addEventListener('focus', function () { (focusables()[0] || drawer).focus(); });
  document.addEventListener('focusin', function (event) {
    if (isOpen && !drawer.contains(event.target)) drawer.querySelector('[data-cart-close]').focus();
  });
  window.CartDrawer = { close: close, isOpen: function () { return isOpen; } };
  window.Shopify.AjaxifyCart = { open: showCart };
});
